var paragraph_default = {
  "fontElementMap": "sI9KG",
  "elementSpacing": "YfgYi",
  "text": "MGsLy YfgYi",
  "child": "-d7KU"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
